export const getPrettyFeedbackName = (key: string): string => {
  return key.replace(/\b\w/g, (char) => char.toUpperCase());
};
